import { render, staticRenderFns } from "./alldatas.vue?vue&type=template&id=ccee819e&scoped=true&"
import script from "./alldatas.vue?vue&type=script&lang=js&"
export * from "./alldatas.vue?vue&type=script&lang=js&"
import style0 from "./alldatas.vue?vue&type=style&index=0&id=ccee819e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccee819e",
  null
  
)

export default component.exports